import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { CodeIcon, PaletteIcon, CameraIcon, ServerIcon, CpuIcon, ArrowRightIcon, CheckIcon } from 'lucide-react';
import { AnimatedSection, AnimatedChildren, AnimatedChild } from '../components/ui/AnimatedSection';
import { MaskReveal } from '../components/ui/MaskReveal';
import { Parallax3D } from '../components/ui/Parallax3D';
const services = [{
  slug: 'digital-engineering',
  icon: CodeIcon,
  title: 'Digital Engineering',
  description: 'Wir entwickeln maßgeschneiderte Softwarelösungen, die Ihre Geschäftsprozesse optimieren und neue digitale Möglichkeiten erschließen.',
  features: ['Individualsoftware & Web-Applikationen', 'Plattformen & Portale', 'API-Entwicklung & Schnittstellen', 'Prozessautomatisierung', 'Datenbanken & Backend-Systeme'],
  image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6?w=800&q=80'
}, {
  slug: 'corporate-design',
  icon: PaletteIcon,
  title: 'Corporate Design & Marke',
  description: 'Wir schaffen visuelle Identitäten, die Ihre Marke unverwechselbar machen und Vertrauen bei Ihrer Zielgruppe aufbauen.',
  features: ['Markenstrategie & Positionierung', 'Logo & Corporate Identity', 'Designsysteme & UI-Kits', 'Brand Guidelines', 'Kommunikationsdesign'],
  image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=800&q=80'
}, {
  slug: 'foto-video',
  icon: CameraIcon,
  title: 'Foto & Videoproduktion',
  description: 'Professionelle visuelle Inhalte, die Ihre Botschaft transportieren und Ihre Marke emotional erlebbar machen.',
  features: ['Imagefilme & Unternehmensvideos', 'Produktfotografie', 'Social Media Content', 'Drohnenaufnahmen', 'Postproduktion & Editing'],
  image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&q=80'
}, {
  slug: 'technische-loesungen',
  icon: ServerIcon,
  title: 'Technische Lösungen',
  description: 'Robuste technische Infrastruktur, die Ihre digitalen Systeme zuverlässig und performant betreibt.',
  features: ['Systemintegration', 'Cloud-Migration & -Architektur', 'Performance-Optimierung', 'DevOps & CI/CD', 'Monitoring & Wartung'],
  image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&q=80'
}, {
  slug: 'ki-automation',
  icon: CpuIcon,
  title: 'KI & Automation',
  description: 'Intelligente Automatisierungslösungen, die repetitive Aufgaben übernehmen und datenbasierte Entscheidungen ermöglichen.',
  features: ['Prozessautomatisierung', 'KI-Integration in bestehende Systeme', 'Chatbots & virtuelle Assistenten', 'Datenanalyse & Business Intelligence', 'Workflow-Optimierung'],
  image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80'
}];
export function ServicesPage() {
  return <div className="w-full" data-id="element-595">
      {/* Hero */}
      <section className="py-24 md:py-32 bg-[#0C0C0F]" data-id="element-596">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-597">
          <AnimatedSection data-id="element-598">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tightest gradient-text max-w-3xl" data-id="element-599">
              Unsere Leistungen
            </h1>
          </AnimatedSection>
          <AnimatedSection delay={0.1} data-id="element-600">
            <p className="mt-6 text-lg md:text-xl text-white/50 max-w-2xl" data-id="element-601">
              Full-Service-Lösungen für Ihre digitale Transformation. Von der
              Strategie über Design und Entwicklung bis zur langfristigen
              Betreuung.
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* Services List */}
      <section className="py-24 md:py-32 bg-[#09090B]" data-id="element-602">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-603">
          <div className="space-y-24 md:space-y-32" data-id="element-604">
            {services.map((service, index) => <AnimatedSection key={service.slug} data-id="element-605">
                <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`} data-id="element-606">
                  <div className={index % 2 === 1 ? 'lg:order-2' : ''} data-id="element-607">
                    <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-6" data-id="element-608">
                      <service.icon className="w-7 h-7 text-[#E8781A]" data-id="element-609" />
                    </div>
                    <h2 className="text-3xl md:text-4xl font-bold tracking-tightest text-white" data-id="element-610">
                      {service.title}
                    </h2>
                    <p className="mt-4 text-lg text-white/50 leading-relaxed" data-id="element-611">
                      {service.description}
                    </p>
                    <ul className="mt-8 space-y-3" data-id="element-612">
                      {service.features.map(feature => <li key={feature} className="flex items-start gap-3" data-id="element-613">
                          <CheckIcon className="w-5 h-5 text-[#E8781A] mt-0.5 flex-shrink-0" data-id="element-614" />
                          <span className="text-white/60" data-id="element-615">{feature}</span>
                        </li>)}
                    </ul>
                    <div className="mt-8" data-id="element-616">
                      <Link to={`/leistungen/${service.slug}`} className="inline-flex items-center text-base font-medium text-white/60 hover:text-[#E8781A] transition-colors" data-id="element-617">
                        Mehr erfahren
                        <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-618" />
                      </Link>
                    </div>
                  </div>
                  <div className={index % 2 === 1 ? 'lg:order-1' : ''} data-id="element-619">
                    <MaskReveal className="aspect-[4/3] rounded-2xl overflow-hidden" direction={index % 2 === 0 ? 'right' : 'left'} data-id="element-620">
                      <Parallax3D className="w-full h-full" tiltX={5} tiltY={index % 2 === 0 ? 3 : -3} shiftY={30} data-id="element-621">
                        <div className="relative w-full h-full group" data-id="element-622">
                          <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-623" />
                          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors" data-id="element-624" />
                        </div>
                      </Parallax3D>
                    </MaskReveal>
                  </div>
                </div>
              </AnimatedSection>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 md:py-32 bg-gradient-to-br from-[#E8781A]/10 via-[#09090B] to-[#a855f7]/10 border-y border-white/5" data-id="element-625">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-12" data-id="element-626">
          <AnimatedSection data-id="element-627">
            <div className="max-w-3xl mx-auto text-center" data-id="element-628">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tightest text-white" data-id="element-629">
                Welche Herausforderung dürfen wir für Sie lösen?
              </h2>
              <p className="mt-6 text-lg text-white/50" data-id="element-630">
                Lassen Sie uns in einem unverbindlichen Gespräch herausfinden,
                wie wir Sie am besten unterstützen können.
              </p>
              <div className="mt-10" data-id="element-631">
                <Link to="/kontakt" className="inline-flex items-center justify-center px-8 py-4 bg-white text-[#09090B] font-medium rounded-lg hover:bg-white/90 transition-colors" data-id="element-632">
                  Kontakt aufnehmen
                  <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-633" />
                </Link>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </section>
    </div>;
}